import React from 'react';
import { connect } from 'react-redux';
import { Preloader, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { getOrderTariffTexts } from "../../../store/selectors/orderTariffCommon";
import { getButtonLoadingStatus } from "../../../store/selectors/modal";
// selectors
import { getTariffDetails } from "../../../store/selectors/tariffDetails";
// components
import { ContentHeader } from "../../common/ContentHeader";
import { ModalLayout } from "../../common/ModalLayout";
import { TariffCard } from "../../common/TariffCard";
import { TariffModuleProvider } from "../../common/TariffModuleProvider";
// styles
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _AlternativeTariff = function _AlternativeTariff(_ref) {
  var tariff = _ref.tariff,
    texts = _ref.texts,
    isLoading = _ref.isLoading;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    "data-t-id": "Steps-AlternativeTariff"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    title: texts.title,
    "data-t-id": "Steps-AlternativeTariff"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "size6-r"
  }, texts.description), isLoading ? /*#__PURE__*/React.createElement("div", {
    className: cx('preloader')
  }, /*#__PURE__*/React.createElement(Preloader, {
    color: "contentPlaceholder",
    size: "l"
  })) : tariff.title && /*#__PURE__*/React.createElement("div", {
    className: cx('tariff-card', 'mar-b-3xl')
  }, /*#__PURE__*/React.createElement(TariffModuleProvider, {
    data: tariff
  }, /*#__PURE__*/React.createElement(TariffCard, {
    "data-t-id": "Steps-AlternativeTariff"
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    tariff: getTariffDetails(state),
    texts: getOrderTariffTexts(state).alternativeTariffTexts,
    isLoading: getButtonLoadingStatus(state)
  };
};
var connector = connect(mapStateToProps);
export var AlternativeTariff = compose(connector(_AlternativeTariff));